import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

type Props = {
    text?: string;
    color?: "inherit" | "success" | "primary" | "secondary" | "error" | "info" | "warning";
}

export default function CircularProgressWithText({ text, color }: Props) {
    const colorClass = color === "success" ? "text-green-500" : 
                       color === "primary" ? "text-[var(--color-primary)]" :
                       color === "error" ? "text-red-500" :
                       "text-[var(--color-primary)]";

    return (
        <div className="flex flex-col justify-center items-center w-full max-w-[400px]">
            <span className={cn(
                "font-bold mb-2.5 text-center",
                "text-[var(--color-primary)] dark:text-[var(--color-primary)]"
            )}>
                {text}
            </span>
            <Loader2 className={cn("h-8 w-8 animate-spin", colorClass)} />
        </div>
    )
}